import { NgwWebmapItem } from '@nextgis/ngw-kit';
import { treeSome } from '@nextgis/tree';

import type { Scene3DTreeItem } from './interfaces';
import type { ItemOptions } from '@nextgis/item';
import type NgwConnector from '@nextgis/ngw-connector';
import type { TreeGroup, TreeLayer, TreeRoot } from '@nextgis/ngw-kit';
import type { WebMap } from '@nextgis/webmap';

export class Scene3DLayerItem extends NgwWebmapItem {
  static options: ItemOptions = {
    properties: [
      {
        type: 'boolean',
        name: 'visibility',
        getProperty(layer?: Scene3DLayerItem): boolean {
          if (layer) {
            const layerItem = layer.item as
              | TreeRoot
              | TreeGroup
              | TreeLayer
              | Scene3DTreeItem;
            if (
              layerItem.item_type === 'group' ||
              layerItem.item_type === 'root'
            ) {
              return treeSome<
                TreeGroup | TreeLayer | TreeRoot | Scene3DTreeItem
              >(
                layerItem,
                (i) => ('visible' in i ? i.visible : false),
                (i) => (i as TreeGroup).children,
              );
            } else if (layerItem.item_type === 'item') {
              return layerItem.visible;
            } else if (layerItem.item_type === 'layer') {
              return layerItem.layer_enabled;
            }
          }
          return false;
        },
        onSet(
          value: boolean,
          options?: Record<string, any>,
          layer?: Scene3DLayerItem,
        ): void {
          if (layer) {
            const layerItem = layer.item as
              | TreeGroup
              | TreeLayer
              | Scene3DTreeItem;
            if (
              layerItem.item_type === 'layer' ||
              layerItem.item_type === 'item'
            ) {
              if (layer.layer) {
                if (value) {
                  layer.webMap.showLayer(layer.layer);
                } else {
                  layer.webMap.hideLayer(layer.layer);
                }
              }
              if (layerItem.item_type === 'layer') {
                layerItem['layer_enabled'] = value;
              } else {
                layerItem['visible'] = value;
              }
            }
          }
        },
      },
    ],
  };

  constructor(
    public webMap: WebMap,
    item: TreeGroup | TreeLayer,
    options?: ItemOptions,
    connector?: NgwConnector,
    parent?: NgwWebmapItem,
  ) {
    super(
      webMap,
      item,
      { ...Scene3DLayerItem.options, ...options },
      connector,
      parent,
    );
  }

  protected getItemOptions(item: TreeGroup | TreeLayer): Record<string, any> {
    const options = super.getItemOptions(item);
    //@ts-ignore
    const zOffset = item.payload && item.payload.zOffset;
    if (zOffset !== undefined) {
      options.params = options.params || {};
      options.params.zOffset = zOffset;
    }
    return options;
  }
}
